import { React, useContext } from "react";
import { AppContext } from "../contexts/AppContext";
const InfoComponent = () => {
  const { info, setInfo } = useContext(AppContext);

  return (
    <>
      {info !== undefined && (
        <div className={"panel card info "} id="panelInfo">
          <panel-title id="info">
            <span>Information</span>
            <span
              id="minified"
              onClick={() => {
                var element = document.getElementById("panelInfo");
                console.log(element);
                element.classList.add("minified");
                setTimeout(function () {
                  setInfo();
                }, 1000);
              }}
            >
              <b>−</b>
            </span>
          </panel-title>
          <panel-body>
            <div className="with-icon">
              <img id="angleIcon" src={info.icon} alt="angleIcon"></img>
              <p>{info.text}</p>
            </div>
          </panel-body>
        </div>
      )}
    </>
  );
};
export default InfoComponent;
